const index = () => import(/* webpackChunkName: "herb" */ './Index');
const edit = () => import(/* webpackChunkName: "herb" */ './Edit');

export default {
  routes: [
    //项目
    {
      path: '/herb/v2/index',
      name: 'index',
      component: index,
      meta:{public:true}
    },
    {
      path: '/herb/v2/edit/:dbid?',
      name: 'edit',
      component: edit,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/herb/v2/router.js